export enum RatingScaleEnum {
  ONE_TO_THREE_SATISFIED = 'ONE_TO_THREE_SATISFIED',
  ONE_TO_THREE_CERTAINLY = 'ONE_TO_THREE_CERTAINLY',
  ONE_TO_FIVE = 'ONE_TO_FIVE'
}

export const ratingScaleEnumMapping: Record<RatingScaleEnum, string> = {
  [RatingScaleEnum.ONE_TO_THREE_SATISFIED]: '1 - 3 Satisfait',
  [RatingScaleEnum.ONE_TO_THREE_CERTAINLY]: '1 - 3 Certainement',
  [RatingScaleEnum.ONE_TO_FIVE]: '1 - 5 Très bien'
}
